<template>
    <div id='BoxList' class='row'>
        <div class='col-12'>
            <div class='row'>
                <div class='col-12 ListOfBoxes'>
                    <List
                        :initialReportState='report'
                        :allowExport='false'
                        listType='Box'
                        @manage-box-contents='manageBoxContents'
                        @print-shipping-label='printShippingLabel'
                        @print-commercial-invoice='printCommercialInvoice'
                        @delete='deleteItem'
                    >
                        <template v-slot:buttons>
                            <Button 
                                btnAction='link'
                                btnTarget='/buy-tracker/box-create'
                                CTA='Create New Box'
                                type='primary'
                                btnClass='BtnCreate'
                            />
                        </template>
                    </List>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TextBox from '../../../core/form/TextBox.vue';
    import Button from '../../../core/form/Button.vue';
    import DisplayIcon from '../../../icons/DisplayIcon';
    import List from '../../../core/list/List';
    export default{
        name: 'BoxList',
        components: {
            TextBox,
            Button,
            DisplayIcon,
            List
        },
        computed: {
            report() {
                var report = this.$store.getters['BuyTracker/BoxCreate/boxReportList'];
                return report ? report : this.$store.getters['BuyTracker/BoxCreate/boxReportList'];
            }
        },
        methods:{
            manageBoxContents(){
                console.log('manageBoxContents reached!!')
            },
            printShippingLabel(){
                console.log('Print-label reached!!')
            },
            printCommercialInvoice(){
                console.log('printLoa reached!!')
            },
            deleteItem(){
                console.log('deleteItem reached!!')
            }
        }
    }
</script>